// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"7e6dfe57","364":"b5612c90","404":"e63c0816","428":"02a08f08","627":"3cc56bda","835":"ace98392","861":"9fa7eab4"}[chunkId] + ".chunk.css";
};